// Central handling of authentication expiry for the app domain.
// Symfony /api/v2/* returns 401 when the PHP session is gone; the legacy /api/*
// returns 403 with an object-shaped body when the JWT is expired or invalid
// (the Symfony 403 body carries `error` as a string, so it can never match).
export const AUTH_EXPIRED_STORAGE_KEY = 'authSessionExpired';

const REDIRECT_GUARD_STORAGE_KEY = 'authExpiredRedirectAt';
const REDIRECT_LOOP_WINDOW_MS = 5000;
const LEGACY_TOKEN_MESSAGES = ['Token expired', 'Invalid token'];
const LOGIN_URL = '/moncompte/index.php';

let redirectInFlight = false;

export function isAuthExpiredError(error) {
    if (!error) {
        return false;
    }
    if (error.status === 401) {
        return true;
    }
    if (error.status === 403 && LEGACY_TOKEN_MESSAGES.includes(error.response?.error?.message)) {
        return true;
    }
    return error.code === 'NO_JWT_TOKEN';
}

/**
 * Redirects to the login page when the given API error means the auth expired.
 * Returns true when the redirect was triggered (callers must then swallow the
 * error instead of throwing, so nothing surfaces while the page unloads).
 * Candidate pages (outside /moncompte) and public endpoints are never redirected.
 */
export function handleAuthExpiry(error, url, isPublicEndpoint) {
    if (!isAuthExpiredError(error) || isPublicEndpoint) {
        return false;
    }
    if (!window.location.pathname.startsWith('/moncompte')) {
        return false;
    }
    if (redirectInFlight) {
        return true;
    }

    // Loop breaker: if the login page itself triggers a non-public 401, do not
    // bounce again within the window (the guard key is never consumed by views).
    const lastRedirectAt = Number(sessionStorage.getItem(REDIRECT_GUARD_STORAGE_KEY));
    if (lastRedirectAt && Date.now() - lastRedirectAt < REDIRECT_LOOP_WINDOW_MS) {
        return false;
    }

    redirectInFlight = true;
    error.authExpired = true;
    sessionStorage.setItem(REDIRECT_GUARD_STORAGE_KEY, String(Date.now()));
    sessionStorage.setItem(AUTH_EXPIRED_STORAGE_KEY, String(Date.now()));
    window.location.assign(LOGIN_URL);
    return true;
}
